/**
 * Caches the signed-in user's avatar URL in localStorage so the AutoClipper
 * Chrome extension can show it in its popup. The extension's content script
 * on app.autoclipper.live reads the cached `user` (from /api/users/me, which
 * does not populate media) and this key — never the token.
 *
 * Cleared together with `token`/`user` on logout.
 */
export const PROFILE_PICTURE_STORAGE_KEY = 'profilePictureUrl';

export function cacheProfilePicture(storage: Storage, url: string | null | undefined): void {
  if (url) storage.setItem(PROFILE_PICTURE_STORAGE_KEY, url);
  else storage.removeItem(PROFILE_PICTURE_STORAGE_KEY);
}

export function clearProfilePicture(storage: Storage): void {
  storage.removeItem(PROFILE_PICTURE_STORAGE_KEY);
}
